const AvailableTier = {
  rates: [
    {
      rate: '23.98p',
      values: [
        {
          resolution: 'UHD',
          label: 'DNxHR 444',
          bit_rate: 1332.88
        },
        {
          resolution: 'UHD',
          label: 'DNxHR HQ(X)',
          bit_rate: 666.08
        },
        {
          resolution: 'UHD',
          label: 'DNxHR SQ',
          bit_rate: 440.56
        },
        {
          resolution: 'UHD',
          label: 'DNxHR LB',
          bit_rate: 336.09
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 444',
          bit_rate: 333.44
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 175(X)/ DNxHR HQ(X)',
          bit_rate: 175
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 115/ DNxHR SQ',
          bit_rate: 115
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 36/ DNxHR LB',
          bit_rate: 36
        },
        {
          resolution: '1280x720',
          label: 'DNxLB',
          bit_rate: 15.09
        },
        {
          resolution: '960x540',
          label: 'DNxLB',
          bit_rate: 9.09
        },
        {
          resolution: '480x270',
          label: 'DNxLB',
          bit_rate: 2.34
        },
        {
          resolution: '360x180',
          label: 'DNxLB',
          bit_rate: 1.59
        },
        {
          resolution: 'Avid Proxy',
          label: 'h264 800Kb',
          bit_rate: 0.8
        },
        {
          resolution: 'Avid Proxy',
          label: 'H264 2Mb',
          bit_rate: 2
        },
        {
          resolution: 'Web Proxy',
          label: 'H264',
          bit_rate: 1.5
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444 XQ',
          bit_rate: 1591
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444',
          bit_rate: 1061
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 HQ',
          bit_rate: 707
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422',
          bit_rate: 471
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 LT',
          bit_rate: 328
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 Proxy',
          bit_rate: 145
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444 XQ',
          bit_rate: 396
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444',
          bit_rate: 264
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 HQ',
          bit_rate: 176
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422',
          bit_rate: 117
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 LT',
          bit_rate: 82
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 Proxy',
          bit_rate: 36
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444 XQ',
          bit_rate: 198
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444',
          bit_rate: 132
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 HQ',
          bit_rate: 88
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422',
          bit_rate: 59
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 LT',
          bit_rate: 41
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 Proxy',
          bit_rate: 18
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM HD 422',
          bit_rate: 50
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM 35',
          bit_rate: 35
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM 17.5',
          bit_rate: 17.5
        },
        {
          resolution: '1920x1080',
          label: 'XAVC 100',
          bit_rate: 89
        },
        {
          resolution: '1280x720',
          label: 'XAVC 100',
          bit_rate: 44
        },
        {
          resolution: 'UHD',
          label: 'XAVC 300 (VBR) (CBG)',
          bit_rate: 240
        },
        {
          resolution: 'UHD',
          label: 'XAVC 480 (VBR) (CBG)',
          bit_rate: 384
        },
        {
          resolution: 'UHD',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 3185
        },
        {
          resolution: '1920x1080',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 796
        },
        {
          resolution: '1280x720',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 353
        },
        {
          resolution: '960x540',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 199
        },
        {
          resolution: 'custom',
          label: 'custom',
          bit_rate: 0
        }
      ]
    },
    {
      rate: '25p/50i',
      values: [
        {
          resolution: 'UHD',
          label: 'DNxHR 444',
          bit_rate: 1389.84
        },
        {
          resolution: 'UHD',
          label: 'DNxHR HQ(X)',
          bit_rate: 694.56
        },
        {
          resolution: 'UHD',
          label: 'DNxHR SQ',
          bit_rate: 459.36
        },
        {
          resolution: 'UHD',
          label: 'DNxHR LB',
          bit_rate: 350.1
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 444',
          bit_rate: 347.68
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 185(X)/ DNxHR HQ(X)',
          bit_rate: 185
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 120/ DNxHR SQ',
          bit_rate: 120
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 36/ DNxHR LB',
          bit_rate: 36
        },
        {
          resolution: '1280x720',
          label: 'DNxLB',
          bit_rate: 15.72
        },
        {
          resolution: '960x540',
          label: 'DNxLB',
          bit_rate: 9.47
        },
        {
          resolution: '480x270',
          label: 'DNxLB',
          bit_rate: 2.44
        },
        {
          resolution: '360x180',
          label: 'DNxLB',
          bit_rate: 1.66
        },
        {
          resolution: 'Avid Proxy',
          label: 'h264 800Kb',
          bit_rate: 0.8
        },
        {
          resolution: 'Avid Proxy',
          label: 'H264 2Mb',
          bit_rate: 2
        },
        {
          resolution: 'Web Proxy',
          label: 'H264',
          bit_rate: 1.5
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444 XQ',
          bit_rate: 1659
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444',
          bit_rate: 1106
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 HQ',
          bit_rate: 737
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422',
          bit_rate: 492
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 LT',
          bit_rate: 342
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 Proxy',
          bit_rate: 151
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444 XQ',
          bit_rate: 413
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444',
          bit_rate: 275
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 HQ',
          bit_rate: 184
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422',
          bit_rate: 122
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 LT',
          bit_rate: 85
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 Proxy',
          bit_rate: 38
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444 XQ',
          bit_rate: 206
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444',
          bit_rate: 138
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 HQ',
          bit_rate: 92
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 HQ',
          bit_rate: 61
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 LT',
          bit_rate: 42
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 Proxy',
          bit_rate: 19
        },
        {
          resolution: 'PAL',
          label: 'IMX 30',
          bit_rate: 30
        },
        {
          resolution: 'PAL',
          label: 'IMX 40',
          bit_rate: 40
        },
        {
          resolution: 'PAL',
          label: 'IMX 50',
          bit_rate: 50
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM HD 422',
          bit_rate: 50
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM 35',
          bit_rate: 35
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM 17.5',
          bit_rate: 17.5
        },
        {
          resolution: '1920x1080',
          label: 'XAVC 100',
          bit_rate: 93
        },
        {
          resolution: '1280x720',
          label: 'XAVC 100',
          bit_rate: 46
        },
        {
          resolution: 'UHD',
          label: 'XAVC 300 (VBR) (CBG)',
          bit_rate: 250
        },
        {
          resolution: 'UHD',
          label: 'XAVC 480 (VBR) (CBG)',
          bit_rate: 400
        },
        {
          resolution: 'UHD',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 3317
        },
        {
          resolution: '1920x1080',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 829
        },
        {
          resolution: '1280x720',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 369
        },
        {
          resolution: '960x540',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 207
        },
        {
          resolution: 'custom',
          label: 'custom',
          bit_rate: 0
        }
      ]
    },
    {
      rate: '29.97p/59.94i',
      values: [
        {
          resolution: 'UHD',
          label: 'DNxHR 444',
          bit_rate: 1666.16
        },
        {
          resolution: 'UHD',
          label: 'DNxHR HQ(X)',
          bit_rate: 832.64
        },
        {
          resolution: 'UHD',
          label: 'DNxHR SQ',
          bit_rate: 550.72
        },
        {
          resolution: 'UHD',
          label: 'DNxHR LB',
          bit_rate: 419.7
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 444',
          bit_rate: 416.8
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 220(X)/ DNxHR HQ(X)',
          bit_rate: 220
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 145/ DNxHR SQ',
          bit_rate: 145
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 45/ DNxHR LB',
          bit_rate: 45
        },
        {
          resolution: '1280x720',
          label: 'DNxLB',
          bit_rate: 18.85
        },
        {
          resolution: '960x540',
          label: 'DNxLB',
          bit_rate: 11.36
        },
        {
          resolution: '480x270',
          label: 'DNxLB',
          bit_rate: 2.93
        },
        {
          resolution: '360x180',
          label: 'DNxLB',
          bit_rate: 1.99
        },
        {
          resolution: 'Avid Proxy',
          label: 'h264 800Kb',
          bit_rate: 0.8
        },
        {
          resolution: 'Avid Proxy',
          label: 'H264 2Mb',
          bit_rate: 2
        },
        {
          resolution: 'Web Proxy',
          label: 'H264',
          bit_rate: 1.5
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444 XQ',
          bit_rate: 1989
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444',
          bit_rate: 1326
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 HQ',
          bit_rate: 884
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422',
          bit_rate: 589
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 LT',
          bit_rate: 410
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 Proxy',
          bit_rate: 182
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444 XQ',
          bit_rate: 495
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444',
          bit_rate: 330
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 HQ',
          bit_rate: 220
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422',
          bit_rate: 147
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 LT',
          bit_rate: 102
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 Proxy',
          bit_rate: 45
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444 XQ',
          bit_rate: 247
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444',
          bit_rate: 165
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 HQ',
          bit_rate: 110
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 HQ',
          bit_rate: 73
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 LT',
          bit_rate: 51
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 Proxy',
          bit_rate: 23
        },
        {
          resolution: 'NTSC',
          label: 'IMX 30',
          bit_rate: 30
        },
        {
          resolution: 'NTSC',
          label: 'IMX 40',
          bit_rate: 40
        },
        {
          resolution: 'NTSC',
          label: 'IMX 50',
          bit_rate: 50
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM HD 422',
          bit_rate: 50
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM 35',
          bit_rate: 35
        },
        {
          resolution: '1920x1080',
          label: 'XDCAM 17.5',
          bit_rate: 17.5
        },
        {
          resolution: '1920x1080',
          label: 'XAVC 100',
          bit_rate: 111
        },
        {
          resolution: '1280x720',
          label: 'XAVC 100',
          bit_rate: 55
        },
        {
          resolution: 'UHD',
          label: 'XAVC 300 (VBR) (CBG)',
          bit_rate: 300
        },
        {
          resolution: 'UHD',
          label: 'XAVC 480 (VBR) (CBG)',
          bit_rate: 480
        },
        {
          resolution: 'UHD',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 3981
        },
        {
          resolution: '1920x1080',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 995
        },
        {
          resolution: '1280x720',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 442
        },
        {
          resolution: '960x540',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 248
        },
        {
          resolution: 'custom',
          label: 'custom',
          bit_rate: 0
        }
      ]
    },
    {
      rate: '50p',
      values: [
        {
          resolution: 'UHD',
          label: 'DNxHR 444',
          bit_rate: 2779.68
        },
        {
          resolution: 'UHD',
          label: 'DNxHR HQ(X)',
          bit_rate: 1389.04
        },
        {
          resolution: 'UHD',
          label: 'DNxHR SQ',
          bit_rate: 918.72
        },
        {
          resolution: 'UHD',
          label: 'DNxHR LB',
          bit_rate: 700.2
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 444',
          bit_rate: 695.28
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 220(X)/ DNxHR HQ(X)',
          bit_rate: 365
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 240/ DNxHR SQ',
          bit_rate: 240
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 75/ DNxHR LB',
          bit_rate: 75
        },
        {
          resolution: '1280x720',
          label: 'DNxHD 175(X)',
          bit_rate: 175
        },
        {
          resolution: '1280x720',
          label: 'DNxHD 115',
          bit_rate: 115
        },
        {
          resolution: '960x540',
          label: 'DNxLB',
          bit_rate: 18.95
        },
        {
          resolution: '480x270',
          label: 'DNxLB',
          bit_rate: 4.88
        },
        {
          resolution: '360x180',
          label: 'DNxLB',
          bit_rate: 3.13
        },
        {
          resolution: 'Avid Proxy',
          label: 'h264 800Kb',
          bit_rate: 0.8
        },
        {
          resolution: 'Avid Proxy',
          label: 'H264 2Mb',
          bit_rate: 2
        },
        {
          resolution: 'Web Proxy',
          label: 'H264',
          bit_rate: 1.5
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444 XQ',
          bit_rate: 3318
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444',
          bit_rate: 2212
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 HQ',
          bit_rate: 1475
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422',
          bit_rate: 983
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 LT',
          bit_rate: 584
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 Proxy',
          bit_rate: 303
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444 XQ',
          bit_rate: 826
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444',
          bit_rate: 551
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 HQ',
          bit_rate: 367
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422',
          bit_rate: 245
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 LT',
          bit_rate: 170
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 Proxy',
          bit_rate: 76
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444 XQ',
          bit_rate: 413
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444',
          bit_rate: 275
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 HQ',
          bit_rate: 184
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422',
          bit_rate: 122
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 LT',
          bit_rate: 84
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 Proxy',
          bit_rate: 38
        },
        {
          resolution: '1920x1080',
          label: 'XAVC 100',
          bit_rate: 185
        },
        {
          resolution: '1280x720',
          label: 'XAVC 100',
          bit_rate: 92
        },
        {
          resolution: 'UHD',
          label: 'XAVC 300 (VBR) (CBG)',
          bit_rate: 500
        },
        {
          resolution: 'UHD',
          label: 'XAVC 480 (VBR) (CBG)',
          bit_rate: 800
        },
        {
          resolution: 'UHD',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 6633
        },
        {
          resolution: '1920x1080',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 1689
        },
        {
          resolution: '1280x720',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 737
        },
        {
          resolution: '960x540',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 414
        },
        {
          resolution: 'custom',
          label: 'custom',
          bit_rate: 0
        }
      ]
    },
    {
      rate: '59.94p',
      values: [
        {
          resolution: 'UHD',
          label: 'DNxHR 444',
          bit_rate: 3332.32
        },
        {
          resolution: 'UHD',
          label: 'DNxHR HQ(X)',
          bit_rate: 1665.2
        },
        {
          resolution: 'UHD',
          label: 'DNxHR SQ',
          bit_rate: 1101.36
        },
        {
          resolution: 'UHD',
          label: 'DNxHR LB',
          bit_rate: 839.39
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 444',
          bit_rate: 833.52
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 440(X)/ DNxHR HQ(X)',
          bit_rate: 440
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 290/ DNxHR SQ',
          bit_rate: 290
        },
        {
          resolution: '1920x1080',
          label: 'DNxHD 90/ DNxHR LB',
          bit_rate: 90
        },
        {
          resolution: '1280x720',
          label: 'DNxHD 220 (X)',
          bit_rate: 220
        },
        {
          resolution: '1280x720',
          label: 'DNxHD 145',
          bit_rate: 145
        },
        {
          resolution: '1280x720',
          label: 'DNxLB',
          bit_rate: 37.7
        },
        {
          resolution: '960x540',
          label: 'DNxLB',
          bit_rate: 22.71
        },
        {
          resolution: '480x270',
          label: 'DNxLB',
          bit_rate: 5.85
        },
        {
          resolution: '360x180',
          label: 'DNxLB',
          bit_rate: 3.98
        },
        {
          resolution: 'Avid Proxy',
          label: 'h264 800Kb',
          bit_rate: 0.8
        },
        {
          resolution: 'Avid Proxy',
          label: 'H264 2Mb',
          bit_rate: 2
        },
        {
          resolution: 'Web Proxy',
          label: 'H264',
          bit_rate: 1.5
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444 XQ',
          bit_rate: 3977
        },
        {
          resolution: 'UHD',
          label: 'ProRes 4444',
          bit_rate: 1193
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 HQ',
          bit_rate: 1768
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422',
          bit_rate: 1178
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 LT',
          bit_rate: 821
        },
        {
          resolution: 'UHD',
          label: 'ProRes 422 Proxy',
          bit_rate: 363
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444 XQ',
          bit_rate: 990
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 4444',
          bit_rate: 660
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 HQ',
          bit_rate: 440
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422',
          bit_rate: 293
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 LT',
          bit_rate: 204
        },
        {
          resolution: '1920x1080',
          label: 'ProRes 422 Proxy',
          bit_rate: 91
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444 XQ',
          bit_rate: 495
        },
        {
          resolution: '1280x720',
          label: 'ProRes 4444',
          bit_rate: 330
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 HQ',
          bit_rate: 220
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422',
          bit_rate: 147
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 LT',
          bit_rate: 101
        },
        {
          resolution: '1280x720',
          label: 'ProRes 422 Proxy',
          bit_rate: 45
        },
        {
          resolution: '1920x1080',
          label: 'XAVC 100',
          bit_rate: 222
        },
        {
          resolution: '1280x720',
          label: 'XAVC 100',
          bit_rate: 111
        },
        {
          resolution: 'UHD',
          label: 'XAVC 300 (VBR) (CBG)',
          bit_rate: 600
        },
        {
          resolution: 'UHD',
          label: 'XAVC 480 (VBR) (CBG)',
          bit_rate: 960
        },
        {
          resolution: 'UHD',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 7963
        },
        {
          resolution: '1920x1080',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 1990
        },
        {
          resolution: '1280x720',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 884
        },
        {
          resolution: '960x540',
          label: 'Uncompressed 422 8 bits',
          bit_rate: 498
        },
        {
          resolution: 'custom',
          label: 'custom',
          bit_rate: 0
        }
      ]
    }
  ]
};

export default AvailableTier;
